export default {
  h1: {
    fontFamily: 'body',
    fontSize: '3xl',
    fontWeight: 'bold',
    lineHeight: 'base',
  },
  subtitle1: {
    fontFamily: 'body',
    fontSize: 'xl',
    fontWeight: 'semibold',
    lineHeight: 'base',
  },
  subtitle2: {
    fontFamily: 'body',
    fontSize: 'lg',
    fontWeight: 'medium',
    lineHeight: 'base',
  },
  body1: {
    fontFamily: 'body',
    fontSize: 'md',
    fontWeight: 'normal',
    lineHeight: 'base',
  },
  body2: {
    fontFamily: 'body',
    fontSize: 'sm',
    fontWeight: 'normal',
    lineHeight: 'base',
  },
  caption: {
    fontFamily: 'body',
    fontSize: 'xs',
    fontWeight: 'normal',
    lineHeight: 'base',
  },
  overline: {
    fontFamily: 'body',
    fontSize: '2xs',
    fontWeight: 'normal',
    lineHeight: 'base',
  },
  inherit: {},
};
